import { api } from 'redux/api/index.api';

export const fileUploadApi = api.injectEndpoints({
  endpoints: builder => ({
    initUpload: builder.mutation({
      query: ({ size, type, name, hash, mediaId, previousMediaId }) => ({
        url: `medias/init-upload`,
        method: 'POST',
        body: {
          total_bytes: size,
          mime_type: type,
          filename: name,
          md5: hash,
          media_id: mediaId,
          previous_media_id: previousMediaId,
        },
      }),
      transformResponse: response => ({
        mediaId: response.media_id,
        chunkId: response.chunk_id,
      }),
    }),
    uploadChunk: builder.mutation({
      query: ({ formData, projectId, mediaId }) => ({
        url: `v1.2/projects/${projectId}/medias/${mediaId}/append-upload`,
        method: 'POST',
        body: formData,
        headers: { 'x-skip-content-type': 'true' },
      }),
    }),
    completeUpload: builder.mutation({
      query: ({ projectId, mediaId, chunkId }) => ({
        url: `v1.2/projects/${projectId}/medias/${mediaId}/finalize-upload`,
        method: 'POST',
        body: {
          chunk_id: chunkId,
        },
      }),
    }),
    directUpload: builder.mutation({
      query: ({ formData, projectId }) => ({
        url: `v1.2/projects/${projectId}/medias/uploads`,
        method: 'POST',
        body: formData,
        headers: { 'x-skip-content-type': 'true' },
      }),
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useUploadChunkMutation,
  useCompleteUploadMutation,
  useInitUploadMutation,
  useDirectUploadMutation,
} = api;
